import { useGetQuotesQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';

// Quotes are not paginated in the UI. Accounts realistically have well under ~25
// accepted quotes, so we fetch them all in a single request. The backend defaults
// pageLength to 10, so without this override any quotes beyond the first 10 would
// be silently dropped and unreachable. 50 leaves comfortable headroom over the
// realistic ceiling while staying under the CRM search per-page cap (the backend
// requests pageLength + 1 from CRM search to detect a next page).
const ALL_QUOTES_PAGE_LENGTH = 50;
export function useQuotesData() {
  var _data$results;
  const {
    loading,
    error,
    data
  } = useGetQuotesQuery({
    variables: {
      pageLength: ALL_QUOTES_PAGE_LENGTH
    },
    fetchPolicy: 'cache-and-network'
  });
  return {
    loading,
    error,
    data: (_data$results = data === null || data === void 0 ? void 0 : data.results) !== null && _data$results !== void 0 ? _data$results : []
  };
}